import React, { forwardRef } from 'react';
import Directions from '@polestar/component-warehouse-react/tokens/directions/Directions';
import DirectionProvider from '@polestar/component-warehouse-react/contexts/direction';
import styled from '@emotion/styled';
const Direction = forwardRef(({ children, dir = Directions.leftToRight, ...props }, ref) => {
    return (React.createElement(DirectionProvider, { forcedDirection: dir },
        React.createElement(DirectionContainer, { ref: ref, ...props, dir: dir }, children)));
});
Direction.displayName = 'Direction';
export default Direction;
export const LeftToRightContent = forwardRef((props, ref) => React.createElement(Direction, { ref: ref, dir: Directions.leftToRight, ...props }));
LeftToRightContent.displayName = 'LeftToRightContent';
export const RightToLeftContent = forwardRef((props, ref) => React.createElement(Direction, { ref: ref, dir: Directions.rightToLeft, ...props }));
RightToLeftContent.displayName = 'RightToLeftContent';
const DirectionContainer = styled.div ``;
DirectionContainer.displayName = `DirectionContainer`;
